import { FinancialIncome, FinancialIncomePropName } from '../../../../models/project/financial/financial-income.model';
import { GenericErrors, ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { ValidationInterface } from '../../validation.interface';

export class FinancialIncomeValidation implements ValidationInterface {
  /** The current financial income obj that is being validated */
  private readonly income: FinancialIncome;

  /**
   * Sets the income that will be used for validation
   * @param income will be used to set the current income obj
   */
  constructor(income: FinancialIncome) {
    if (!income) {
      throw Error('invalid income provided for validation');
    }
    this.income = new FinancialIncome(income);
  }

  /**
   * Get a validation unit containing the validation data for the current income obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.income) throw Error('unable to validate income');
    const validationUnit = new ProjectValidationUnit();
    if (this.income.name) {
      validationUnit.setValid(FinancialIncomePropName.name);
    } else {
      validationUnit.setInvalid(FinancialIncomePropName.name, [GenericErrors.MissingName]);
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.income.income).getValidation(),
      FinancialIncomePropName.income
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.income.period).getValidation(),
      FinancialIncomePropName.period
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.income.cpi).getValidation(),
      FinancialIncomePropName.cpi
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current financial income obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
